export default {
  FlightTime__ARRIVES_ARIA_LABEL: "arrives",
  FlightTime__DEPARTS_ARIA_LABEL: "departs",
};
